module.exports = __webpack_public_path__ + "img/price.00cd16d1.svg";